export const UserRoleIds = {
  Admin: 1,
  DataEntry: 2,
  User: 10,
};
